module.exports = __webpack_public_path__ + "img/8.0fc6f885.jpg";